import { render, staticRenderFns } from "./MembroTurma.vue?vue&type=template&id=5947a0b3"
import script from "./MembroTurma.vue?vue&type=script&lang=js"
export * from "./MembroTurma.vue?vue&type=script&lang=js"
import style0 from "./MembroTurma.vue?vue&type=style&index=0&id=5947a0b3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports